import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doBATCH_DELETE_PARTICIPANT} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_DELETE = 'REQUEST_PARTICIPANT_DELETE'
export const doREQUEST_PARTICIPANT_DELETE = createDoRequestAction(REQUEST_PARTICIPANT_DELETE)

export const requestParticipantDeleteActionCreators = {
  doREQUEST_PARTICIPANT_DELETE,
}

export function* requestParticipantDelete({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestParticipantDelete')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantId: v.string().exist(),
        batchId: v.string().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {participantId, batchId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/participant-delete`,
    accessToken,
    data: {
      participantId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/participant-delete',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doBATCH_DELETE_PARTICIPANT({
      batchId,
      participantId,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantDeleteSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_DELETE, requestParticipantDelete)
}
